module.exports = __webpack_public_path__ + "img/battery_c.a5f297bc.svg";